
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.531 6h12.938l5.313 6.375.5.594-.5.656-11.781 15-.781-1-11-14-.5-.656.5-.594 5-6zm.938 2l-3.344 4h4.313l2.688-4H10.47zm7.406 0l2.688 4h4.313l-3.344-4h-3.656zM16 8.844L13.875 12h4.25zM7.031 14l6.594 8.406L11.25 14H7.031zm6.282 0l2.688 9.313L18.657 14h-5.344zm7.437 0l-2.375 8.375L24.969 14H20.75z"}})])
          )
        }
      }
    